//@ts-check
import React from 'react';
import { Table } from './Table/Table';

export const CompleteTableView = (props) => {
  return (
      <Table {...props.data} mode="view"></Table>
  );
};
